export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL
export const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN || ''